import { HomeworkList } from './HomeworkList';
export default HomeworkList;
